import { $qs, $qsa } from '@js/utils/querySelector'
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

function footerLogosSlider() {
  const sliderElement = $qs('[data-target="footer-logos-slider"]')

  if (sliderElement) {
    const swiper = new Swiper(sliderElement, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 5,
      spaceBetween: 30,
      loop: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        320: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
        640: {
          slidesPerView: 5,
          spaceBetween: 50,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 50,
        },
        1536: {
          slidesPerView: 3,
          spaceBetween: 35,
        },
      },
      speed: 5000,
      grabCursor: true,
    })
  }
}

function footer() {
  footerLogosSlider()
}

export default footer
